import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { interval, Observable, of,Subject,BehaviorSubject } from 'rxjs';
import { switchMap, takeWhile, catchError, tap } from 'rxjs/operators';
import { ProcessStatus,FieldConfig,StartProcessPayload,FormCompletionStatus,UserInvolvement } from 'src/app/features/camunda/status.model';
import { mainApiRoutes } from 'src/app/data/main-datasource/config/main.apiroutes'; 
import { environment } from 'src/environments/environment';
import { MainHeadersService } from 'src/app/data/main-datasource/config/main-headers.service';

@Injectable({
  providedIn: 'root'
})
export class CamundaFacadeService {
  constructor( private http: HttpClient,private mainHeadersService: MainHeadersService) {
    // You can now use camundaService and http in this facade
  } 



 
  activeForm: FieldConfig[];
  private formDataAccordingToUser = new BehaviorSubject<FormCompletionStatus[]>([]);
  formDataAccordingToUser$=this.formDataAccordingToUser.asObservable();
  private currentFormData:FormCompletionStatus[];
  private curentDataformCamunda = new BehaviorSubject<FormCompletionStatus[]>([]);
  private showNotification = new BehaviorSubject<boolean>(false);
  showNotification$ = this.showNotification.asObservable();
  private camundaVaribles  = new BehaviorSubject<FormCompletionStatus[]>([]);
  camundaVaribles$=this.camundaVaribles.asObservable();
  currentEmail;
  allowPendingAccess: boolean = false;
  private completedFormsList = new BehaviorSubject<any[]>([]);
  completedFormsList$=this.completedFormsList.asObservable();
  processStarted=false;
  
  
  returnProcessStarted(){
    return this.processStarted;
  }

  getIfUserIsInvolved(email: string): Observable<any> {
    let url = environment.apiRootUrl + mainApiRoutes.CAMUNDA_GET_IF_USER_INVOLVED(email);
    return this.http.get<any>(url);
   }

   getIfUserIsInvolvedWithManipulation(email: string): Observable<any> {
    let url = environment.apiRootUrl + mainApiRoutes.CAMUNDA_GET_IF_USER_INVOLVED(email);
    return this.http.get<UserInvolvement>(url);
  }

  startProcess(email: string): Observable<any> {   
    this.currentEmail=email;
    const payload: StartProcessPayload = new StartProcessPayload(email);
    let headers  = this.mainHeadersService.HTTP_CLIENT_HEADERS();
    const url = environment.apiRootUrl + mainApiRoutes.CAMUNDA_START_PROCESS;

    // Send POST request to start the process
    return this.http.post(url, payload, { headers }).pipe(
      tap(response => {
      
      }),
      switchMap(() => this.pollProcessStatus( this.currentEmail)),
      catchError(error => {
        console.error('Error starting process:', error);
        return of(null); // Return a fallback value or handle the error as needed
      })
    );
  }




  pollProcessStatus(email: string,pending:boolean=false): Observable<any> {
  
  
    return interval(2000).pipe(
      switchMap(() => this.checkStatus(email, pending)),
      takeWhile((statusdata) => { 
        

        if(this.getCurrentFormData().length>0){
        return false;
        }
        return true;      
    },true),
      catchError((error) => {
        console.error('Error checking status', error);
        return of(null);
       
      })
    );
  }

  GetCorrectStatusAccordingtoEmail(data:FormCompletionStatus[],email:string,pending:boolean=false):FormCompletionStatus[]{
    this.showNotification.next(false);
    let arr=[]
    let dataObj:FormCompletionStatus;   
    
    data.forEach((DataEl) => {
    
      if(email!=DataEl.businessKey){
        
        if(email==DataEl["assignedTo"]){          
          this.showNotification.next(true);

        }

      }
    
      if(pending==true){
        this.showNotification.next(false);
        if(email!=DataEl.businessKey){
          if(email==DataEl["assignedTo"]){
            dataObj=DataEl;
            arr.push(DataEl);    
          }
        }	
   
    }else{
      if(email==DataEl.businessKey){
        if(email==DataEl["assignedTo"]){
          dataObj=DataEl;
          arr.push(DataEl);    
        }
      }
    }
    });
 
 
    return arr;
  }



  getCurrentFormData(): FormCompletionStatus[] {
    return this.curentDataformCamunda.getValue();
  }


  CheckIfProcessHasStarted(businessKey: string): Observable<any> {
    let url = environment.apiRootUrl + mainApiRoutes.CAMUNDA_HAS_PROCESS_STARTED(businessKey);
    return this.http.get<any>(url);
  }




  checkStatus(businessKey: string, pending: boolean = false): Observable<FormCompletionStatus[]> {
   
    let url = environment.apiRootUrl + mainApiRoutes.CAMUNDA_GET_PENDING_PROCESS(businessKey);
    const headers = this.mainHeadersService.HTTP_CLIENT_HEADERS();
    
    return this.http.get<FormCompletionStatus[]>(url, { headers }).pipe(
      switchMap(data => {
       
       
        
        if (data && data.length > 0) {
 
          this.currentFormData = this.GetCorrectStatusAccordingtoEmail(data, businessKey, pending);
         
          this.curentDataformCamunda.next(data);

              
          this.formDataAccordingToUser.next(this.currentFormData);

 
          return this.getCamundaData(data[0].processInstanceId).pipe(
            switchMap(camundaData => {
                 
          
              if (typeof camundaData === 'object' && Object.keys(camundaData).length > 0) {            
                this.camundaVaribles.next(camundaData);
              }
             
             
              return this.getCompletedForms(businessKey,pending);
            })
          );
        } else {
          this.formDataAccordingToUser.next(data);
              
          return this.getCompletedForms(businessKey,pending); // Return the original data if no processInstanceId is found
        }
      }),
      catchError(error => {
        console.error('Error fetching status', error);
        return of(null); // Return null or handle the error as needed
      })
    );
  }


  private getKeyBusiness(pending: boolean, businessKey: string): string {
    if (pending) {
      return this.currentFormData[0].businessKey;
    } else {
      return businessKey;
    }
  }
 
 getCamundaData(id: string): Observable<any> { 
 
    let url = environment.apiRootUrl + mainApiRoutes.CAMUNDA_GET_DATA + id;
    const headers = this.mainHeadersService.HTTP_CLIENT_HEADERS();
    return this.http.get<any>(url, { headers }).pipe(
      tap(data => {
            
       

       
      }),
      catchError(error => {
        console.error('Error fetching data', error);
        return of(null); 
      })
    );
  }

  getCompletedForms(email: string, pending: boolean = false): Observable<any> {

    return this.getIfUserIsInvolvedWithManipulation(email).pipe(
      switchMap(userInvolvement => {
        this.completedFormsList.next(undefined);
        let userEmail;
        if (pending) {
          userEmail = userInvolvement["businessKey"];
        } else {
          userEmail = email;
        }
        return this.getCompletedSteps(userEmail);
      }),
      catchError(error => {
        console.error('Error in user involvement check, continuing with original email', error);
        let userEmail = email;
        return this.getCompletedSteps(userEmail);
      })
    );
  }
  
  private getCompletedSteps(userEmail: string): Observable<any> {
    let url = environment.apiRootUrl + mainApiRoutes.CAMUNDA_GET_COMPLETED_STEPS(userEmail);
    const headers = this.mainHeadersService.HTTP_CLIENT_HEADERS();
    return this.http.get<any>(url, { headers }).pipe(
      tap(data => {
        if (data === undefined || data["step"] == "") {
          this.processStarted = true;
        } else {
          this.processStarted = false;
        }
        this.completedFormsList.next(data);
      }),
      catchError(error => {
        console.error('Error fetching completed forms', error);
        return of(null); // Return null or handle the error as needed
      })
    );
  }




postForm(formData: any,email,pending: boolean = false): Observable<any> {
  let businessKey: string = formData["formInfo"].businessKey;
  let formName: string = formData["formInfo"].formName;
  let assignedTo: string = formData["formInfo"].assignedTo;

  const url = environment.apiRootUrl + mainApiRoutes.CAMUNDA_POST_FORM(businessKey, formName, assignedTo);
  
  const headers = this.mainHeadersService.HTTP_CLIENT_HEADERS().set('Content-Type', 'application/json');
 
  return this.http.post(url, formData["formValues"], { headers }).pipe(
    tap(response => { 

      
      
                
      this.pollProcessStatus(email,pending).subscribe(
        statusdata => {
       
        },
        error => {
          console.error('Error during polling:', error);
        }
      );
    }),
    catchError(error => {
      console.error('Error submitting form', error);
      return of(null); // Return null or handle the error as needed
    })
  );
}
}






